import {
  Box,
  Button,
  Flex,
  FormLabel,
  HStack,
  Input,
  Text,
} from '@chakra-ui/core';
import { ChevronRightIcon, WarningIcon } from '@chakra-ui/icons';
import crypto from 'crypto';
import { utils } from 'eciesjs';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import InfoValidationStack, {
  InfoValidation,
} from '../../components/InfoValidationStack';
import { RootState } from '../../store/reducers';

interface WalletPasswordSetupProps {
  onBack?: () => void;
  onNext: () => void;
}
const WalletPasswordSetup = ({ onBack, onNext }: WalletPasswordSetupProps) => {
  const [password, setPassword] = useState('');

  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [passwordMatchingError, setPasswordMatchingError] = useState(false);

  const mnemonic = useSelector((state: RootState) => state.wallet.mnemonic);

  const validations: InfoValidation[] = [
    {
      label: '8 characters minimum',
      valid: password.length >= 8,
    },
    {
      label: 'One number',
      valid: /\d/.test(password),
    },
    {
      label: 'One special character',
      valid: /[^a-zA-Z0-9]/.test(password),
    },
  ];

  const isValid =
    validations.every((validation) => validation.valid) &&
    password === passwordConfirmation;

  const handleEncrypt = () => {
    if (!isValid) return;

    const passwordKey = crypto.createHash('sha256').update(password).digest();

    const encryptedMnemonic = utils
      .aesEncrypt(passwordKey, Buffer.from(mnemonic, 'utf8'))
      .toString('base64');

    window.localStorage.setItem('encryptedMnemonic', encryptedMnemonic);
    localStorage.setItem('shownNewFeature', 'true');

    onNext();
  };

  return (
    <>
      <Flex flexDir="column">
        <HStack spacing={4}>
          <Box>
            <FormLabel fontSize="md">Wallet Password</FormLabel>
            <Input
              placeholder="Enter Password Here"
              type="password"
              name="new_password"
              value={password}
              onBlur={() => {
                if (passwordConfirmation)
                  setPasswordMatchingError(password !== passwordConfirmation);
              }}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Box>
          <Box>
            <FormLabel fontSize="md">Confirm Password</FormLabel>
            <Flex alignItems="center">
              <Input
                placeholder="Confirm Password"
                type="password"
                name="confirm_password"
                value={passwordConfirmation}
                onBlur={() =>
                  setPasswordMatchingError(password !== passwordConfirmation)
                }
                onChange={(e) => setPasswordConfirmation(e.target.value)}
              />
              {passwordMatchingError && (
                <WarningIcon ml={4} color="red.500" boxSize="14px" />
              )}
            </Flex>
          </Box>
        </HStack>

        <Text fontSize="xs" my={2}>
          Password should have
        </Text>
        <InfoValidationStack validations={validations} />
      </Flex>
      <Flex flexDir="row" mt={4}>
        {onBack && <Button onClick={onBack}>Go Back</Button>}

        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={handleEncrypt}
          type="submit"
          disabled={!isValid}
        >
          Setup Wallet
        </Button>
      </Flex>
    </>
  );
};

export default WalletPasswordSetup;
